import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { createContext, useReducer, useMemo } from 'react';
import { SET_FAJITA_QUESTIONNAIRE_FORM } from './constants';
const initialState = {
  fajitaQuestionnaireFormGlobal: null
};
const initFormsGlobalContext = {
  fajitaQuestionnaireFormGlobal: null
};
export const FormsGlobalContextReducer = (state, action) => {
  let newState = _objectSpread({}, state);

  switch (action.type) {
    case SET_FAJITA_QUESTIONNAIRE_FORM:
      newState.fajitaQuestionnaireFormGlobal = action.payload;
      break;

    default:
      newState = state;
      break;
  }

  return newState;
};
export const FormsGlobalContext = /*#__PURE__*/createContext(initFormsGlobalContext);
export const FormsGlobalDispatchContext = /*#__PURE__*/createContext({});
export const FormsGlobalContextConsumer = FormsGlobalContext.Consumer;
export const FormsGlobalDispatchContextConsumer = FormsGlobalDispatchContext.Consumer;
export const FormsGlobalContextProvider = ({
  children
}) => {
  const [{
    fajitaQuestionnaireFormGlobal
  }, dispatch] = useReducer(FormsGlobalContextReducer, initialState);
  const context = useMemo(() => ({
    fajitaQuestionnaireFormGlobal,
    dispatchQuestionnaire: dispatch
  }), [fajitaQuestionnaireFormGlobal, dispatch]);
  return /*#__PURE__*/React.createElement(FormsGlobalContext.Provider, {
    value: context
  }, children);
};
export function withFormsGlobalContext(Component) {
  return function contextComponent(props) {
    return /*#__PURE__*/React.createElement(FormsGlobalContextConsumer, null, context => /*#__PURE__*/React.createElement(FormsGlobalDispatchContextConsumer, null, dispatchContext => /*#__PURE__*/React.createElement(Component, _extends({}, props, context, dispatchContext))));
  };
}
export default FormsGlobalContext;